"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable:no-consecutive-blank-lines ordered-imports align trailing-comma enum-naming
// tslint:disable:whitespace no-unbound-method no-trailing-whitespace
// tslint:disable:no-unused-variable

var base_contract_1 = require("@0x/base-contract");

var json_schemas_1 = require("@0x/json-schemas");

var utils_1 = require("@0x/utils");

var web3_wrapper_1 = require("@0x/web3-wrapper");

var assert_1 = require("@0x/assert");

var ethers = require("ethers"); // tslint:enable:no-unused-variable

/* istanbul ignore next */
// tslint:disable:array-type
// tslint:disable:no-parameter-reassignment
// tslint:disable-next-line:class-name


var IERC20BridgeSamplerContract =
/** @class */
function (_super) {
  __extends(IERC20BridgeSamplerContract, _super);

  function IERC20BridgeSamplerContract(address, supportedProvider, txDefaults, logDecodeDependencies, deployedBytecode) {
    if (deployedBytecode === void 0) {
      deployedBytecode = IERC20BridgeSamplerContract.deployedBytecode;
    }

    var _this = _super.call(this, 'IERC20BridgeSampler', IERC20BridgeSamplerContract.ABI(), address, supportedProvider, txDefaults, logDecodeDependencies, deployedBytecode) || this;

    _this._methodABIIndex = {};
    utils_1.classUtils.bindAll(_this, ['_abiEncoderByFunctionSignature', 'address', '_web3Wrapper']);
    IERC20BridgeSamplerContract.ABI().forEach(function (item, index) {
      if (item.type === 'function') {
        var methodAbi = item;
        _this._methodABIIndex[methodAbi.name] = index;
      }
    });
    return _this;
  }

  IERC20BridgeSamplerContract.deployFrom0xArtifactAsync = function (artifact, supportedProvider, txDefaults, logDecodeDependencies) {
    return __awaiter(this, void 0, void 0, function () {
      var e_1, _a, provider, bytecode, abi, logDecodeDependenciesAbiOnly, _b, _c, key;

      return __generator(this, function (_d) {
        assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [json_schemas_1.schemas.addressSchema, json_schemas_1.schemas.numberSchema, json_schemas_1.schemas.jsNumber]);

        if (artifact.compilerOutput === undefined) {
          throw new Error('Compiler output not found in the artifact file');
        }

        provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
        bytecode = artifact.compilerOutput.evm.bytecode.object;
        abi = artifact.compilerOutput.abi;
        logDecodeDependenciesAbiOnly = {};

        if (Object.keys(logDecodeDependencies) !== undefined) {
          try {
            for (_b = __values(Object.keys(logDecodeDependencies)), _c = _b.next(); !_c.done; _c = _b.next()) {
              key = _c.value;
              logDecodeDependenciesAbiOnly[key] = logDecodeDependencies[key].compilerOutput.abi;
            }
          } catch (e_1_1) {
            e_1 = {
              error: e_1_1
            };
          } finally {
            try {
              if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        }

        return [2
        /*return*/
        , IERC20BridgeSamplerContract.deployAsync(bytecode, abi, provider, txDefaults, logDecodeDependenciesAbiOnly)];
      });
    });
  };

  IERC20BridgeSamplerContract.deployWithLibrariesFrom0xArtifactAsync = function (artifact, libraryArtifacts, supportedProvider, txDefaults, logDecodeDependencies) {
    return __awaiter(this, void 0, void 0, function () {
      var e_2, _a, provider, abi, logDecodeDependenciesAbiOnly, _b, _c, key, libraryAddresses, bytecode;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [json_schemas_1.schemas.addressSchema, json_schemas_1.schemas.numberSchema, json_schemas_1.schemas.jsNumber]);

            if (artifact.compilerOutput === undefined) {
              throw new Error('Compiler output not found in the artifact file');
            }

            provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
            abi = artifact.compilerOutput.abi;
            logDecodeDependenciesAbiOnly = {};

            if (Object.keys(logDecodeDependencies) !== undefined) {
              try {
                for (_b = __values(Object.keys(logDecodeDependencies)), _c = _b.next(); !_c.done; _c = _b.next()) {
                  key = _c.value;
                  logDecodeDependenciesAbiOnly[key] = logDecodeDependencies[key].compilerOutput.abi;
                }
              } catch (e_2_1) {
                e_2 = {
                  error: e_2_1
                };
              } finally {
                try {
                  if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally {
                  if (e_2) throw e_2.error;
                }
              }
            }

            return [4
            /*yield*/
            , IERC20BridgeSamplerContract._deployLibrariesAsync(artifact, libraryArtifacts, new web3_wrapper_1.Web3Wrapper(provider), txDefaults)];

          case 1:
            libraryAddresses = _d.sent();
            bytecode = base_contract_1.linkLibrariesInBytecode(artifact, libraryAddresses);
            return [2
            /*return*/
            , IERC20BridgeSamplerContract.deployAsync(bytecode, abi, provider, txDefaults, logDecodeDependenciesAbiOnly)];
        }
      });
    });
  };

  IERC20BridgeSamplerContract.deployAsync = function (bytecode, abi, supportedProvider, txDefaults, logDecodeDependencies) {
    return __awaiter(this, void 0, void 0, function () {
      var provider, constructorAbi, iface, deployInfo, txData, web3Wrapper, txDataWithDefaults, txHash, txReceipt, contractInstance;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert_1.assert.isHexString('bytecode', bytecode);
            assert_1.assert.doesConformToSchema('txDefaults', txDefaults, json_schemas_1.schemas.txDataSchema, [json_schemas_1.schemas.addressSchema, json_schemas_1.schemas.numberSchema, json_schemas_1.schemas.jsNumber]);
            provider = utils_1.providerUtils.standardizeOrThrow(supportedProvider);
            constructorAbi = base_contract_1.BaseContract._lookupConstructorAbi(abi);

            base_contract_1.BaseContract._formatABIDataItemList(constructorAbi.inputs, [], base_contract_1.BaseContract._bigNumberToString);

            iface = new ethers.utils.Interface(abi);
            deployInfo = iface.deployFunction;
            txData = deployInfo.encode(bytecode, []);
            web3Wrapper = new web3_wrapper_1.Web3Wrapper(provider);
            return [4
            /*yield*/
            , base_contract_1.BaseContract._applyDefaultsToContractTxDataAsync(__assign({
              data: txData
            }, txDefaults), web3Wrapper.estimateGasAsync.bind(web3Wrapper))];

          case 1:
            txDataWithDefaults = _a.sent();
            return [4
            /*yield*/
            , web3Wrapper.sendTransactionAsync(txDataWithDefaults)];

          case 2:
            txHash = _a.sent();
            utils_1.logUtils.log("transactionHash: " + txHash);
            return [4
            /*yield*/
            , web3Wrapper.awaitTransactionSuccessAsync(txHash)];

          case 3:
            txReceipt = _a.sent();
            utils_1.logUtils.log("IERC20BridgeSampler successfully deployed at " + txReceipt.contractAddress);
            contractInstance = new IERC20BridgeSamplerContract(txReceipt.contractAddress, provider, txDefaults, logDecodeDependencies);
            contractInstance.constructorArgs = [];
            return [2
            /*return*/
            , contractInstance];
        }
      });
    });
  };
  /**
   * @returns      The contract ABI
   */


  IERC20BridgeSamplerContract.ABI = function () {
    var abi = [{
      constant: true,
      inputs: [{
        name: 'callDatas',
        type: 'bytes[]'
      }],
      name: 'batchCall',
      outputs: [{
        name: 'callResults',
        type: 'bytes[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'registryAddress',
        type: 'address'
      }, {
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }],
      name: 'getLiquidityProviderFromRegistry',
      outputs: [{
        name: 'providerAddress',
        type: 'address'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'orders',
        type: 'tuple[]',
        components: [{
          name: 'makerAddress',
          type: 'address'
        }, {
          name: 'takerAddress',
          type: 'address'
        }, {
          name: 'feeRecipientAddress',
          type: 'address'
        }, {
          name: 'senderAddress',
          type: 'address'
        }, {
          name: 'makerAssetAmount',
          type: 'uint256'
        }, {
          name: 'takerAssetAmount',
          type: 'uint256'
        }, {
          name: 'makerFee',
          type: 'uint256'
        }, {
          name: 'takerFee',
          type: 'uint256'
        }, {
          name: 'expirationTimeSeconds',
          type: 'uint256'
        }, {
          name: 'salt',
          type: 'uint256'
        }, {
          name: 'makerAssetData',
          type: 'bytes'
        }, {
          name: 'takerAssetData',
          type: 'bytes'
        }, {
          name: 'makerFeeAssetData',
          type: 'bytes'
        }, {
          name: 'takerFeeAssetData',
          type: 'bytes'
        }]
      }, {
        name: 'orderSignatures',
        type: 'bytes[]'
      }],
      name: 'getOrderFillableMakerAssetAmounts',
      outputs: [{
        name: 'orderFillableMakerAssetAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'orders',
        type: 'tuple[]',
        components: [{
          name: 'makerAddress',
          type: 'address'
        }, {
          name: 'takerAddress',
          type: 'address'
        }, {
          name: 'feeRecipientAddress',
          type: 'address'
        }, {
          name: 'senderAddress',
          type: 'address'
        }, {
          name: 'makerAssetAmount',
          type: 'uint256'
        }, {
          name: 'takerAssetAmount',
          type: 'uint256'
        }, {
          name: 'makerFee',
          type: 'uint256'
        }, {
          name: 'takerFee',
          type: 'uint256'
        }, {
          name: 'expirationTimeSeconds',
          type: 'uint256'
        }, {
          name: 'salt',
          type: 'uint256'
        }, {
          name: 'makerAssetData',
          type: 'bytes'
        }, {
          name: 'takerAssetData',
          type: 'bytes'
        }, {
          name: 'makerFeeAssetData',
          type: 'bytes'
        }, {
          name: 'takerFeeAssetData',
          type: 'bytes'
        }]
      }, {
        name: 'orderSignatures',
        type: 'bytes[]'
      }],
      name: 'getOrderFillableTakerAssetAmounts',
      outputs: [{
        name: 'orderFillableTakerAssetAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'curveAddress',
        type: 'address'
      }, {
        name: 'fromTokenIdx',
        type: 'int128'
      }, {
        name: 'toTokenIdx',
        type: 'int128'
      }, {
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleBuysFromCurve',
      outputs: [{
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleBuysFromEth2Dai',
      outputs: [{
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }, {
        name: 'opts',
        type: 'tuple',
        components: [{
          name: 'targetSlippageBps',
          type: 'uint256'
        }, {
          name: 'maxIterations',
          type: 'uint256'
        }]
      }],
      name: 'sampleBuysFromKyberNetwork',
      outputs: [{
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'registryAddress',
        type: 'address'
      }, {
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }, {
        name: 'opts',
        type: 'tuple',
        components: [{
          name: 'targetSlippageBps',
          type: 'uint256'
        }, {
          name: 'maxIterations',
          type: 'uint256'
        }]
      }],
      name: 'sampleBuysFromLiquidityProviderRegistry',
      outputs: [{
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleBuysFromUniswap',
      outputs: [{
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'path',
        type: 'address[]'
      }, {
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleBuysFromUniswapV2',
      outputs: [{
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'curveAddress',
        type: 'address'
      }, {
        name: 'fromTokenIdx',
        type: 'int128'
      }, {
        name: 'toTokenIdx',
        type: 'int128'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromCurve',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromEth2Dai',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromKyberNetwork',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'registryAddress',
        type: 'address'
      }, {
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromLiquidityProviderRegistry',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'multibridge',
        type: 'address'
      }, {
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'intermediateToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromMultiBridge',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'takerToken',
        type: 'address'
      }, {
        name: 'makerToken',
        type: 'address'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromUniswap',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }, {
      constant: true,
      inputs: [{
        name: 'path',
        type: 'address[]'
      }, {
        name: 'takerTokenAmounts',
        type: 'uint256[]'
      }],
      name: 'sampleSellsFromUniswapV2',
      outputs: [{
        name: 'makerTokenAmounts',
        type: 'uint256[]'
      }],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }];
    return abi;
  };

  IERC20BridgeSamplerContract._deployLibrariesAsync = function (artifact, libraryArtifacts, web3Wrapper, txDefaults, libraryAddresses) {
    if (libraryAddresses === void 0) {
      libraryAddresses = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var e_3, _a, e_4, _b, links, _c, _d, link, _e, _f, libraryName, libraryArtifact, linkedLibraryBytecode, txDataWithDefaults, txHash, contractAddress, e_4_1, e_3_1;

      return __generator(this, function (_g) {
        switch (_g.label) {
          case 0:
            links = artifact.compilerOutput.evm.bytecode.linkReferences;
            _g.label = 1;

          case 1:
            _g.trys.push([1, 15, 16, 17]);

            _c = __values(Object.values(links)), _d = _c.next();
            _g.label = 2;

          case 2:
            if (!!_d.done) return [3
            /*break*/
            , 14];
            link = _d.value;
            _g.label = 3;

          case 3:
            _g.trys.push([3, 11, 12, 13]);

            _e = __values(Object.keys(link)), _f = _e.next();
            _g.label = 4;

          case 4:
            if (!!_f.done) return [3
            /*break*/
            , 10];
            libraryName = _f.value;
            if (!!libraryAddresses[libraryName]) return [3
            /*break*/
            , 9];
            libraryArtifact = libraryArtifacts[libraryName];

            if (!libraryArtifact) {
              throw new Error("Missing artifact for linked library \"" + libraryName + "\"");
            } // Deploy any dependent libraries used by this library.


            return [4
            /*yield*/
            , IERC20BridgeSamplerContract._deployLibrariesAsync(libraryArtifact, libraryArtifacts, web3Wrapper, txDefaults, libraryAddresses)];

          case 5:
            // Deploy any dependent libraries used by this library.
            _g.sent();

            linkedLibraryBytecode = base_contract_1.linkLibrariesInBytecode(libraryArtifact, libraryAddresses);
            return [4
            /*yield*/
            , base_contract_1.BaseContract._applyDefaultsToContractTxDataAsync(__assign({
              data: linkedLibraryBytecode
            }, txDefaults), web3Wrapper.estimateGasAsync.bind(web3Wrapper))];

          case 6:
            txDataWithDefaults = _g.sent();
            return [4
            /*yield*/
            , web3Wrapper.sendTransactionAsync(txDataWithDefaults)];

          case 7:
            txHash = _g.sent();
            utils_1.logUtils.log("transactionHash: " + txHash);
            return [4
            /*yield*/
            , web3Wrapper.awaitTransactionSuccessAsync(txHash)];

          case 8:
            contractAddress = _g.sent().contractAddress;
            utils_1.logUtils.log(libraryArtifact.contractName + " successfully deployed at " + contractAddress);
            libraryAddresses[libraryArtifact.contractName] = contractAddress;
            _g.label = 9;

          case 9:
            _f = _e.next();
            return [3
            /*break*/
            , 4];

          case 10:
            return [3
            /*break*/
            , 13];

          case 11:
            e_4_1 = _g.sent();
            e_4 = {
              error: e_4_1
            };
            return [3
            /*break*/
            , 13];

          case 12:
            try {
              if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally {
              if (e_4) throw e_4.error;
            }

            return [7
            /*endfinally*/
            ];

          case 13:
            _d = _c.next();
            return [3
            /*break*/
            , 2];

          case 14:
            return [3
            /*break*/
            , 17];

          case 15:
            e_3_1 = _g.sent();
            e_3 = {
              error: e_3_1
            };
            return [3
            /*break*/
            , 17];

          case 16:
            try {
              if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
              if (e_3) throw e_3.error;
            }

            return [7
            /*endfinally*/
            ];

          case 17:
            return [2
            /*return*/
            , libraryAddresses];
        }
      });
    });
  };

  IERC20BridgeSamplerContract.prototype.getFunctionSignature = function (methodName) {
    var index = this._methodABIIndex[methodName];
    var methodAbi = IERC20BridgeSamplerContract.ABI()[index]; // tslint:disable-line:no-unnecessary-type-assertion

    var functionSignature = base_contract_1.methodAbiToFunctionSignature(methodAbi);
    return functionSignature;
  };

  IERC20BridgeSamplerContract.prototype.getABIDecodedTransactionData = function (methodName, callData) {
    var functionSignature = this.getFunctionSignature(methodName);
    var self = this;

    var abiEncoder = self._lookupAbiEncoder(functionSignature);

    var abiDecodedCallData = abiEncoder.strictDecode(callData);
    return abiDecodedCallData;
  };

  IERC20BridgeSamplerContract.prototype.getABIDecodedReturnData = function (methodName, callData) {
    var functionSignature = this.getFunctionSignature(methodName);
    var self = this;

    var abiEncoder = self._lookupAbiEncoder(functionSignature);

    var abiDecodedCallData = abiEncoder.strictDecodeReturnValue(callData);
    return abiDecodedCallData;
  };

  IERC20BridgeSamplerContract.prototype.getSelector = function (methodName) {
    var functionSignature = this.getFunctionSignature(methodName);
    var self = this;

    var abiEncoder = self._lookupAbiEncoder(functionSignature);

    return abiEncoder.getSelector();
  };
  /**
   * Call multiple public functions on this contract in a single transaction.
   * @param callDatas ABI-encoded call data for each function call.
   * @returns callResults ABI-encoded results data for each call.
   */


  IERC20BridgeSamplerContract.prototype.batchCall = function (callDatas) {
    var self = this;
    assert_1.assert.isArray('callDatas', callDatas);
    var functionSignature = 'batchCall(bytes[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [callDatas]);
      }
    };
  };
  /**
   * Returns the address of a liquidity provider for the given market
   * (takerToken, makerToken), from a registry of liquidity providers.
   * Returns address(0) if no such provider exists in the registry.
   * @param takerToken Taker asset managed by liquidity provider.
   * @param makerToken Maker asset managed by liquidity provider.
   * @returns providerAddress Address of the liquidity provider.
   */


  IERC20BridgeSamplerContract.prototype.getLiquidityProviderFromRegistry = function (registryAddress, takerToken, makerToken) {
    var self = this;
    assert_1.assert.isString('registryAddress', registryAddress);
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    var functionSignature = 'getLiquidityProviderFromRegistry(address,address,address)';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [registryAddress.toLowerCase(), takerToken.toLowerCase(), makerToken.toLowerCase()]);
      }
    };
  };
  /**
   * Queries the fillable maker asset amounts of native orders.
   * @param orders Native orders to query.
   * @param orderSignatures Signatures for each respective order in `orders`.
   * @returns orderFillableMakerAssetAmounts How much maker asset can be filled         by each order in &#x60;orders&#x60;.
   */


  IERC20BridgeSamplerContract.prototype.getOrderFillableMakerAssetAmounts = function (orders, orderSignatures) {
    var self = this;
    assert_1.assert.isArray('orders', orders);
    assert_1.assert.isArray('orderSignatures', orderSignatures);
    var functionSignature = 'getOrderFillableMakerAssetAmounts((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes)[],bytes[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [orders, orderSignatures]);
      }
    };
  };
  /**
   * Queries the fillable taker asset amounts of native orders.
   * @param orders Native orders to query.
   * @param orderSignatures Signatures for each respective order in `orders`.
   * @returns orderFillableTakerAssetAmounts How much taker asset can be filled         by each order in &#x60;orders&#x60;.
   */


  IERC20BridgeSamplerContract.prototype.getOrderFillableTakerAssetAmounts = function (orders, orderSignatures) {
    var self = this;
    assert_1.assert.isArray('orders', orders);
    assert_1.assert.isArray('orderSignatures', orderSignatures);
    var functionSignature = 'getOrderFillableTakerAssetAmounts((address,address,address,address,uint256,uint256,uint256,uint256,uint256,uint256,bytes,bytes,bytes,bytes)[],bytes[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [orders, orderSignatures]);
      }
    };
  };
  /**
   * Sample buy quotes from Curve.
   * @param curveAddress Address of the Curve contract.
   * @param fromTokenIdx Index of the taker token (what to sell).
   * @param toTokenIdx Index of the maker token (what to buy).
   * @param makerTokenAmounts Maker token buy amount for each sample.
   * @returns takerTokenAmounts Taker amounts sold at each maker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleBuysFromCurve = function (curveAddress, fromTokenIdx, toTokenIdx, makerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('curveAddress', curveAddress);
    assert_1.assert.isBigNumber('fromTokenIdx', fromTokenIdx);
    assert_1.assert.isBigNumber('toTokenIdx', toTokenIdx);
    assert_1.assert.isArray('makerTokenAmounts', makerTokenAmounts);
    var functionSignature = 'sampleBuysFromCurve(address,int128,int128,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [curveAddress.toLowerCase(), fromTokenIdx, toTokenIdx, makerTokenAmounts]);
      }
    };
  };
  /**
   * Sample buy quotes from Eth2Dai/Oasis.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param makerTokenAmounts Maker token buy amount for each sample.
   * @returns takerTokenAmounts Taker amounts sold at each maker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleBuysFromEth2Dai = function (takerToken, makerToken, makerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('makerTokenAmounts', makerTokenAmounts);
    var functionSignature = 'sampleBuysFromEth2Dai(address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [takerToken.toLowerCase(), makerToken.toLowerCase(), makerTokenAmounts]);
      }
    };
  };
  /**
   * Sample buy quotes from Kyber.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param makerTokenAmounts Maker token buy amount for each sample.
   * @param opts `FakeBuyOptions` specifying target slippage and max iterations.
   * @returns takerTokenAmounts Taker amounts sold at each maker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleBuysFromKyberNetwork = function (takerToken, makerToken, makerTokenAmounts, opts) {
    var self = this;
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('makerTokenAmounts', makerTokenAmounts);
    var functionSignature = 'sampleBuysFromKyberNetwork(address,address,uint256[],(uint256,uint256))';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [takerToken.toLowerCase(), makerToken.toLowerCase(), makerTokenAmounts, opts]);
      }
    };
  };
  /**
   * Sample buy quotes from an arbitrary on-chain liquidity provider.
   * @param registryAddress Address of the liquidity provider registry contract.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param makerTokenAmounts Maker token buy amount for each sample.
   * @param opts `FakeBuyOptions` specifying target slippage and max iterations.
   * @returns takerTokenAmounts Taker amounts sold at each maker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleBuysFromLiquidityProviderRegistry = function (registryAddress, takerToken, makerToken, makerTokenAmounts, opts) {
    var self = this;
    assert_1.assert.isString('registryAddress', registryAddress);
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('makerTokenAmounts', makerTokenAmounts);
    var functionSignature = 'sampleBuysFromLiquidityProviderRegistry(address,address,address,uint256[],(uint256,uint256))';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [registryAddress.toLowerCase(), takerToken.toLowerCase(), makerToken.toLowerCase(), makerTokenAmounts, opts]);
      }
    };
  };
  /**
   * Sample buy quotes from Uniswap.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param makerTokenAmounts Maker token buy amount for each sample.
   * @returns takerTokenAmounts Taker amounts sold at each maker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleBuysFromUniswap = function (takerToken, makerToken, makerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('makerTokenAmounts', makerTokenAmounts);
    var functionSignature = 'sampleBuysFromUniswap(address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [takerToken.toLowerCase(), makerToken.toLowerCase(), makerTokenAmounts]);
      }
    };
  };
  /**
   * Sample buy quotes from UniswapV2.
   * @param path Token route.
   * @param makerTokenAmounts Maker token buy amount for each sample.
   * @returns takerTokenAmounts Taker amounts sold at each maker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleBuysFromUniswapV2 = function (path, makerTokenAmounts) {
    var self = this;
    assert_1.assert.isArray('path', path);
    assert_1.assert.isArray('makerTokenAmounts', makerTokenAmounts);
    var functionSignature = 'sampleBuysFromUniswapV2(address[],uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [path, makerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from Curve.
   * @param curveAddress Address of the Curve contract.
   * @param fromTokenIdx Index of the taker token (what to sell).
   * @param toTokenIdx Index of the maker token (what to buy).
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromCurve = function (curveAddress, fromTokenIdx, toTokenIdx, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('curveAddress', curveAddress);
    assert_1.assert.isBigNumber('fromTokenIdx', fromTokenIdx);
    assert_1.assert.isBigNumber('toTokenIdx', toTokenIdx);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromCurve(address,int128,int128,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [curveAddress.toLowerCase(), fromTokenIdx, toTokenIdx, takerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from Eth2Dai/Oasis.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromEth2Dai = function (takerToken, makerToken, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromEth2Dai(address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [takerToken.toLowerCase(), makerToken.toLowerCase(), takerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from Kyber.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromKyberNetwork = function (takerToken, makerToken, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromKyberNetwork(address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [takerToken.toLowerCase(), makerToken.toLowerCase(), takerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from an arbitrary on-chain liquidity provider.
   * @param registryAddress Address of the liquidity provider registry contract.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromLiquidityProviderRegistry = function (registryAddress, takerToken, makerToken, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('registryAddress', registryAddress);
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromLiquidityProviderRegistry(address,address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [registryAddress.toLowerCase(), takerToken.toLowerCase(), makerToken.toLowerCase(), takerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from MultiBridge.
   * @param multibridge Address of the MultiBridge contract.
   * @param takerToken Address of the taker token (what to sell).
   * @param intermediateToken The address of the intermediate token to        use
   *     in an indirect route.
   * @param makerToken Address of the maker token (what to buy).
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromMultiBridge = function (multibridge, takerToken, intermediateToken, makerToken, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('multibridge', multibridge);
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('intermediateToken', intermediateToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromMultiBridge(address,address,address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [multibridge.toLowerCase(), takerToken.toLowerCase(), intermediateToken.toLowerCase(), makerToken.toLowerCase(), takerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from Uniswap.
   * @param takerToken Address of the taker token (what to sell).
   * @param makerToken Address of the maker token (what to buy).
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromUniswap = function (takerToken, makerToken, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isString('takerToken', takerToken);
    assert_1.assert.isString('makerToken', makerToken);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromUniswap(address,address,uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [takerToken.toLowerCase(), makerToken.toLowerCase(), takerTokenAmounts]);
      }
    };
  };
  /**
   * Sample sell quotes from UniswapV2.
   * @param path Token route.
   * @param takerTokenAmounts Taker token sell amount for each sample.
   * @returns makerTokenAmounts Maker amounts bought at each taker token         amount.
   */


  IERC20BridgeSamplerContract.prototype.sampleSellsFromUniswapV2 = function (path, takerTokenAmounts) {
    var self = this;
    assert_1.assert.isArray('path', path);
    assert_1.assert.isArray('takerTokenAmounts', takerTokenAmounts);
    var functionSignature = 'sampleSellsFromUniswapV2(address[],uint256[])';
    return {
      callAsync: function callAsync(callData, defaultBlock) {
        if (callData === void 0) {
          callData = {};
        }

        return __awaiter(this, void 0, void 0, function () {
          var rawCallResult, abiEncoder;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                base_contract_1.BaseContract._assertCallParams(callData, defaultBlock);

                return [4
                /*yield*/
                , self._performCallAsync(__assign({}, callData, {
                  data: this.getABIEncodedTransactionData()
                }), defaultBlock)];

              case 1:
                rawCallResult = _a.sent();
                abiEncoder = self._lookupAbiEncoder(functionSignature);

                base_contract_1.BaseContract._throwIfUnexpectedEmptyCallResult(rawCallResult, abiEncoder);

                return [2
                /*return*/
                , abiEncoder.strictDecodeReturnValue(rawCallResult)];
            }
          });
        });
      },
      getABIEncodedTransactionData: function getABIEncodedTransactionData() {
        return self._strictEncodeArguments(functionSignature, [path, takerTokenAmounts]);
      }
    };
  };

  IERC20BridgeSamplerContract.contractName = 'IERC20BridgeSampler';
  return IERC20BridgeSamplerContract;
}(base_contract_1.BaseContract);

exports.IERC20BridgeSamplerContract = IERC20BridgeSamplerContract; // tslint:disable:max-file-line-count
// tslint:enable:no-unbound-method no-parameter-reassignment no-consecutive-blank-lines ordered-imports align
// tslint:enable:trailing-comma whitespace no-trailing-whitespace